export default __webpack_public_path__ + "static/media/logo_white.1de2a71f.png";